import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import util from 'util';
import constClass from '../../Constants/Constants';
import { Link } from 'react-router-dom';
import { generatePath } from 'react-router';
import { useToasts } from 'react-toast-notifications';
import moment from 'moment';

const TrainBookingList = (props) => {
  const { condition } = props;
  const [ticketData, setTicketData] = useState(null);
  const [bookData, setBookData] = useState([]);
  const [lockData, setLockData] = useState(false);
  const [sortOrder, setSortOrder] = useState([]); // ソート順指定
  const [paymentData, setPaymentData] = useState([]);
  const { addToast } = useToasts();
  const componentRef = useRef();

  const refreshBook = useCallback(async () => {
    //トークンを取得
    const jwt = localStorage.getItem('jwt');

    var param = {};
    param = {
      "operator": "and",
      "where": [
        { "site_id": props.siteId },
      ]
    }
    const ticketdata = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/search/`, param, { headers: { Authorization: `Bearer ${jwt}` } })).data;
    setTicketData(ticketdata);
    if (props.bookData) {
      setBookData((props.bookData).filter(item => (condition.ticket_id !== '' || condition.bookDate !== '') && (condition.status === '' || condition.status.includes(item.status)) && (condition.ticket_id === '' || condition.ticket_id.includes(item.ticket_id)) && (condition.bookDate === '' || condition.bookDate.replace(/\//g, '-') === item.book_date) && item.status !== constClass.STATUS.UPAY && item.status !== constClass.STATUS.CUPAY));
    
      const bookIds = (props.bookData || [])
        .map(b => b.book_id ? String(b.book_id) : "")
        .filter(id => id !== "");

      const params = {
        operator: 'in',
        attr: "transaction_id",
        val: bookIds
      };
      if (props.bookData.length > 0) {
        const paymentData = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/payment/list/search/`, params, { headers: { Authorization: `Bearer ${jwt}` } })).data;
        setPaymentData(paymentData);
      }
    }
  }, [props.siteId, condition.status, condition.ticket_id, condition.bookDate, props.bookData]);

  const handleStatusButtonClick = async (book_id, data_status, receipt_num, status, line_id) => {
    const jwt = localStorage.getItem('jwt');
    const param = { site_id: props.siteId, book_id };
    const bookstatuspromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/train_booking/back/status/search/`, param, { headers: { Authorization: `Bearer ${jwt}` } });
    const bookingStatus = (await bookstatuspromise).data;

    if (bookingStatus.some(m => m.status !== "REG")) {
      window.alert("ステータスが変更されています");
      await refreshBook();
      return;
    }
    var book = bookData.find(o => (o.book_id === book_id && o.receipt_num === receipt_num));
    var message = "";
    if (book.status === status) {
      return;
    }

    if (status === constClass.STATUS.FIN) {
      message = `予約No[${book.receipt_num}]を乗車済にします。よろしいですか？`;
    }

    if (!window.confirm(message)) {
      return;
    }
    const params = {
      site_id: props.match.params.siteId,
      status,
      line_id: line_id,
      upd_name: props.user.userId
    };
    try {
      setLockData(true);
      //トークンを取得
      const jwt = localStorage.getItem('jwt');

      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/train_booking/backyard_status/${book_id}/${receipt_num}`, params, { headers: { Authorization: `Bearer ${jwt}` } });

      addToast('ステータスを更新しました。', { appearance: 'success', autoDismiss: true });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      await refreshBook();
      setLockData(false);
    }
  }

  const renderCancelButton = (data) => {
    const datalist = (props.bookData).filter(x => x.book_id === data.book_id);
    const chk = datalist.reduce((chk, item) => (chk && constClass.STATUS_PRE.includes(item.status)), true);
    const statusName = "キャンセル";
    const status = (chk) ? constClass.STATUS.CCL : constClass.STATUS.CFIN;
    const additionalStatus = [constClass.STATUS.CCL, constClass.STATUS.CFIN];

    return (
      <Link to={`${generatePath(`${props.match.path}cancel/${data.book_id}/${data.ticket_id}`, { siteId: props.match.params.siteId })}`}><button type="button"
        className={`btn ${additionalStatus.includes(data.status) ? 'btn-danger' : (constClass.ACTIVE_BUTTONS[data.status] && constClass.ACTIVE_BUTTONS[data.status].includes(status) ? 'btn-active' : 'btn-danger')} mx-1`
        }>
        {statusName}
      </button ></Link>
    )
  }

  const renderButton = (data, status, statusName) => {
    return (
      <button type="button"
        disabled={lockData || constClass.STATUS_CCL.includes(data.status) || (status === constClass.STATUS.CCL && !(data.status === constClass.STATUS.CPRE || constClass.STATUS_PRE.includes(data.status))) || (status !== constClass.STATUS.CCL && !constClass.STATUS_RDEOK.includes(data.status))}
        className={`btn btn-success mx-1`}
        onClick={() => handleStatusButtonClick(data.book_id, data.status, data.receipt_num, status, data.line_id)}>
        乗車
      </button>
    )
  }

  const handleHeaderClick = (column) => {
    var _sortOrder = sortOrder;
    if (_sortOrder.map(s => s.column).includes(column)) { // 既に登録済み
      if (_sortOrder[0].column !== column) { // 先頭ではない
        _sortOrder.splice(_sortOrder.findIndex(s => s.column === column), 1); //削除
        _sortOrder.unshift({ column, order: 'ASC' }); // 追加
      } else { //先頭 並び順変更
        _sortOrder[0].order = _sortOrder[0].order === 'ASC' ? 'DESC' : 'ASC';
      }
    } else { //未登録
      _sortOrder.unshift({ column, order: 'ASC' }); // 追加
    }
    if (_sortOrder.length > 3) { //ソート順は3件まで
      _sortOrder.pop();
    }
    setSortOrder(_sortOrder);
    var data = bookData.slice();
    data.sort((a, b) => sortData(a, b));
    setBookData(data);
  }

  const sortData = useCallback((a, b) => {
    if (sortOrder.length <= 0) { // 初期値は予約日・予約時間・予約ID・予約No 昇順
      return (a.book_date !== b.book_date) ? Number(a.book_date) - Number(b.book_date) : (a.ride_time !== b.ride_time) ? Number(a.ride_time) - Number(b.ride_time) : (a.book_id !== b.book_id) ? Number(a.book_id) - Number(b.book_id) : Number(a.receipt_num) - Number(b.receipt_num);
    }
    for (var i = 0; i < sortOrder.length; i++) {
      var item = sortOrder[i];
      if (item.column === 'count') {
        var count_a = a.count_adult1 + a.count_child1 + a.count_adult2 + a.count_child2;
        var count_b = b.count_adult1 + b.count_child1 + b.count_adult2 + b.count_child2;
        if (item.order === 'ASC') {
          if (count_a < count_b) return -1;
          if (count_a > count_b) return 1;
        } else {
          if (count_b < count_a) return -1;
          if (count_b > count_a) return 1;
        }
      } else if (item.column === 'ride_time' || item.column === 'getoff_time') {
        if (item.order === 'ASC') {
          if (Number(a[item.column]) < Number(b[item.column])) return -1;
          if (Number(a[item.column]) > Number(b[item.column])) return 1;
        } else {
          if (Number(b[item.column]) < Number(a[item.column])) return -1;
          if (Number(b[item.column]) > Number(a[item.column])) return 1;
        }
      } else {
        //console.log(a[item.column]);
        if (item.order === 'ASC') {
          if (a[item.column] < b[item.column]) return -1;
          if (a[item.column] > b[item.column]) return 1;
        } else {
          if (b[item.column] < a[item.column]) return -1;
          if (b[item.column] > a[item.column]) return 1;
        }
      }
    }
    return 0;
  }, [sortOrder]);

  const renderSortTh = (column) =>
    <th className="text-center align-middle like-button p-0 m-0" onClick={() => handleHeaderClick(column)}>
      {sortOrder.filter(s => s.column === column).map((item, idx, self) =>
        <span key={idx}>{item.order === 'ASC' ? '▲' : '▼'}{sortOrder.findIndex(s => s.column === column) + 1}</span>
      )}
    </th>

  useEffect(() => {
      refreshBook();
    }, [refreshBook]);

  const renderList = () => {
    return (
      <div ref={componentRef} className="print-list">
        <div className="row mb-0 p-0 ">
        </div>
        <div className="row mb-3 p-0">
          <div className="col-12 p-0">
            {condition.status.includes("REG") &&
              <table className="table table-bbooked table-striped" height="1">
                <thead>
                  <tr>
                    <th className="col-1 text-center align-middle text-nowrap like-button" onClick={() => handleHeaderClick('receipt_num')}>
                      予約<br />番号
                    </th>
                    <th className="col-1 text-center align-middle like-button" onClick={() => handleHeaderClick('ticket_name')}>
                      チケット
                    </th>
                    <th className="col-1 text-center align-middle like-button" onClick={() => handleHeaderClick('count')}>
                      人数
                    </th>
                    <th className="col-2 text-center align-middle like-button" onClick={() => handleHeaderClick('entry_name')}>
                      乗車駅
                    </th>
                    <th className="col-2 text-center align-middle like-button" onClick={() => handleHeaderClick('exit_name')}>
                      降車駅
                    </th>
                    <th className="col-2 text-center align-middle like-button">
                      予約時刻
                    </th>
                    <th className="col-1 text-center align-middle like-button" onClick={() => handleHeaderClick('status')}>
                      ステータス
                    </th>
                    <th className="col-2 text-center align-middle print-none">
                      処理
                    </th>
                  </tr>
                  <tr className="print-none">
                    {renderSortTh('book_id')}
                    {renderSortTh('ticket_name')}
                    {renderSortTh('count')}
                    {renderSortTh('entry_name')}
                    {renderSortTh('exit_name')}
                    {renderSortTh('status')}
                    <th className="text-center align-middle print-none">
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {bookData.length <= 0 && <tr><td className="text-center align-middle p-3" colSpan={10}>条件に一致する予約がありません</td></tr>}
                  {bookData.sort((a, b) => sortData(a, b)).map((data, idx) => (
                    <tr key={idx}>
                      {/* 管理番号 */}
                      <td className="text-center align-middle p-1">
                        {data.book_id}
                      </td>
                      {/* チケット */}
                      <td className="text-center align-middle p-1">
                        {ticketData.find(x => x.ticket_id === Number(data.ticket_id)).ticket_name}
                      </td>
                      {/* 人数 */}
                      <td className="text-center align-middle p-1">
                        {data.count}<br />
                      </td>
                      {/* 乗車駅 */}
                      <td className="text-center align-middle p-1">
                        {(() => {
                          const ticket = ticketData.find(t => t.ticket_id === Number(data.ticket_id));
                          // 条件ごとに判定
                          let foundDetail = null;
                          for (const x of ticket.ticket_detail_data) {
                            if ((x.ticket_id === Number(data.ticket_id)) && data.t_booking_detail.find(b => b.entry_type === "E01" && b.entry_data === x.entry_data)) {
                              foundDetail = x;
                              break;
                            }
                          }
                          return foundDetail.entry_name;
                        })()}
                      </td>
                      {/* 降車駅 */}
                      <td className="text-center align-middle p-1">
                        {(() => {
                          const ticket = ticketData.find(t => t.ticket_id === Number(data.ticket_id));
                          if (!ticket) return 'チケットデータなし';
                          // 条件ごとに判定
                          let foundDetail = null;
                          for (const x of ticket.ticket_detail_data) {
                            const ticketIdMatch = x.ticket_id === Number(data.ticket_id);
                            const bookingDetailMatch = data.t_booking_detail && data.t_booking_detail.find(b => b.entry_type === "E02" && b.entry_data === x.entry_data);
                            if (ticketIdMatch && bookingDetailMatch) {
                              foundDetail = x;
                              break;
                            }
                          }
                          if (!foundDetail) return '詳細データなし';
                          return foundDetail.entry_name;
                        })()}
                      </td>
                      {/* 予約時刻 */}
                      <td className="text-center align-middle p-1">
                        {moment(data.ins_date).format("YYYY年MM月DD日 HH時mm分")}
                      </td>
                      {/* ステータス */}
                      <td className="text-center align-middle p-1">
                        {constClass.STATUS_NAME[data.status]}
                      </td>
                      {/* 処理 */}
                      <td className="text-center align-middle text-nowrap p-1 print-none">
                        {renderButton(data, constClass.STATUS.FIN, constClass.STATUS_NAME.FIN)}
                        {renderCancelButton(data)}
                      </td>
                    </tr>
                  ))
                  }
                </tbody>
              </table>
            }
            {condition.status.includes("FIN") &&
              <table className="table table-bbooked table-striped" height="1">
                <thead>
                  <tr>
                    <th className="col-1 text-center align-middle text-nowrap like-button" onClick={() => handleHeaderClick('receipt_num')}>
                      予約<br />番号
                    </th>
                    <th className="col-2 text-center align-middle like-button" onClick={() => handleHeaderClick('ticket_name')}>
                      チケット
                    </th>
                    <th className="col-1 text-center align-middle like-button" onClick={() => handleHeaderClick('count')}>
                      人数
                    </th>
                    <th className="col-2 text-center align-middle like-button" onClick={() => handleHeaderClick('entry_name')}>
                      乗車駅
                    </th>
                    <th className="col-2 text-center align-middle like-button" onClick={() => handleHeaderClick('exit_name')}>
                      降車駅
                    </th>
                    <th className="col-2 text-center align-middle like-button" onClick={() => handleHeaderClick('status')}>
                      ステータス
                    </th>
                    <th className="col-2 text-center align-middle print-none">
                      処理
                    </th>
                  </tr>
                  <tr className="print-none">
                    {renderSortTh('book_id')}
                    {renderSortTh('ticket_name')}
                    {renderSortTh('count')}
                    {renderSortTh('entry_name')}
                    {renderSortTh('exit_name')}
                    {renderSortTh('status')}
                    <th className="text-center align-middle print-none">
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {bookData.length <= 0 && <tr><td className="text-center align-middle p-3" colSpan={10}>条件に一致する予約がありません</td></tr>}
                  {bookData.sort((a, b) => sortData(a, b)).map((data, idx) => (
                    <tr key={idx}>
                      {/* 管理番号 */}
                      <td className="text-center align-middle p-1">
                        {data.book_id}
                      </td>
                      {/* チケット */}
                      <td className="text-center align-middle p-1">
                        {ticketData.find(x => x.ticket_id === Number(data.ticket_id)).ticket_name}
                      </td>
                      {/* 人数 */}
                      <td className="text-center align-middle p-1">
                        {data.count}<br />
                      </td>
                      {/* 乗車駅 */}
                      <td className="text-center align-middle p-1">
                        {(() => {
                          const ticket = ticketData.find(t => t.ticket_id === Number(data.ticket_id));
                          // 条件ごとに判定
                          let foundDetail = null;
                          for (const x of ticket.ticket_detail_data) {
                            if ((x.ticket_id === Number(data.ticket_id)) && data.t_booking_detail.find(b => b.entry_type === "E01" && b.entry_data === x.entry_data)) {
                              foundDetail = x;
                              break;
                            }
                          }
                          return foundDetail.entry_name;
                        })()}
                      </td>
                      {/* 降車駅 */}
                      <td className="text-center align-middle p-1">
                        {(() => {
                          const ticket = ticketData.find(t => t.ticket_id === Number(data.ticket_id));
                          if (!ticket) return 'チケットデータなし';
                          // 条件ごとに判定
                          let foundDetail = null;
                          for (const x of ticket.ticket_detail_data) {
                            const ticketIdMatch = x.ticket_id === Number(data.ticket_id);
                            const bookingDetailMatch = data.t_booking_detail && data.t_booking_detail.find(b => b.entry_type === "E02" && b.entry_data === x.entry_data);
                            if (ticketIdMatch && bookingDetailMatch) {
                              foundDetail = x;
                              break;
                            }
                          }
                          if (!foundDetail) return '詳細データなし';
                          return foundDetail.entry_name;
                        })()}
                      </td>
                      {/* ステータス */}
                      <td className="text-center align-middle p-1">
                        {constClass.STATUS_NAME[data.status]}
                      </td>
                      {/* 処理 */}
                      <td className="text-center align-middle text-nowrap p-1 print-none">
                        {renderButton(data, constClass.STATUS.FIN, constClass.STATUS_NAME.FIN)}
                        {renderCancelButton(data)}
                      </td>
                    </tr>
                  ))
                  }
                </tbody>
              </table>
            }
            {condition.status.includes("CCL") &&
              <table className="table table-bbooked table-striped" height="1">
                <thead>
                  <tr>
                    <th className="col-1 text-center align-middle text-nowrap like-button" onClick={() => handleHeaderClick('receipt_num')}>
                      予約<br />番号
                    </th>
                    <th className="col-1 text-center align-middle like-button" onClick={() => handleHeaderClick('ticket_name')}>
                      チケット
                    </th>
                    <th className="col-1 text-center align-middle like-button" onClick={() => handleHeaderClick('count')}>
                      人数
                    </th>
                    <th className="col-1 text-center align-middle like-button" onClick={() => handleHeaderClick('entry_name')}>
                      乗車駅
                    </th>
                    <th className="col-1 text-center align-middle like-button" onClick={() => handleHeaderClick('exit_name')}>
                      降車駅
                    </th>
                    <th className="col-2 text-center align-middle like-button">
                      払戻時刻
                    </th>
                    <th className="col-1 text-center align-middle like-button">
                      払戻額
                    </th>
                    <th className="col-1 text-center align-middle like-button">
                      払戻手数料
                    </th>
                    <th className="col-1 text-center align-middle like-button" onClick={() => handleHeaderClick('status')}>
                      ステータス
                    </th>
                    <th className="col-1 text-center align-middle like-button">
                      更新ユーザ
                    </th>
                    <th className="col-1 text-center align-middle print-none">
                      処理
                    </th>
                  </tr>
                  <tr className="print-none">
                    {renderSortTh('book_id')}
                    {renderSortTh('ticket_name')}
                    {renderSortTh('count')}
                    {renderSortTh('entry_name')}
                    {renderSortTh('exit_name')}
                    {renderSortTh('status')}
                    <th className="text-center align-middle print-none">
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {bookData.length <= 0 && <tr><td className="text-center align-middle p-3" colSpan={12}>条件に一致する予約がありません</td></tr>}
                  {bookData.sort((a, b) => sortData(a, b)).map((data, idx) => (
                    <tr key={idx}>
                      {/* 管理番号 */}
                      <td className="text-center align-middle p-1">
                        {data.book_id}
                      </td>
                      {/* チケット */}
                      <td className="text-center align-middle p-1">
                        {ticketData.find(x => x.ticket_id === Number(data.ticket_id)).ticket_name}
                      </td>
                      {/* 人数 */}
                      <td className="text-center align-middle p-1">
                        {data.count}<br />
                      </td>
                      {/* 乗車駅 */}
                      <td className="text-center align-middle p-1">
                        {(() => {
                          const ticket = ticketData.find(t => t.ticket_id === Number(data.ticket_id));
                          // 条件ごとに判定
                          let foundDetail = null;
                          for (const x of ticket.ticket_detail_data) {
                            if ((x.ticket_id === Number(data.ticket_id)) && data.t_booking_detail.find(b => b.entry_type === "E01" && b.entry_data === x.entry_data)) {
                              foundDetail = x;
                              break;
                            }
                          }
                          return foundDetail.entry_name;
                        })()}
                      </td>
                      {/* 降車駅 */}
                      <td className="text-center align-middle p-1">
                        {(() => {
                          const ticket = ticketData.find(t => t.ticket_id === Number(data.ticket_id));
                          if (!ticket) return 'チケットデータなし';
                          // 条件ごとに判定
                          let foundDetail = null;
                          for (const x of ticket.ticket_detail_data) {
                            const ticketIdMatch = x.ticket_id === Number(data.ticket_id);
                            const bookingDetailMatch = data.t_booking_detail && data.t_booking_detail.find(b => b.entry_type === "E02" && b.entry_data === x.entry_data);
                            if (ticketIdMatch && bookingDetailMatch) {
                              foundDetail = x;
                              break;
                            }
                          }
                          if (!foundDetail) return '詳細データなし';
                          return foundDetail.entry_name;
                        })()}
                      </td>
                      {/* 払戻時刻 */}
                      <td className="text-center align-middle p-1">
                        {moment(paymentData.filter(a => Number(a.transaction_id) === Number(data.book_id)).sort((a, b) => Number(b.payment_id) - Number(a.payment_id))[0]?.upd_date).format("YYYY年M月D日H時m分")}
                      </td>
                      {/* 払戻額 */}
                      <td className="text-center align-middle p-1">
                        {data.refund_total ? Number(data.refund_total) : 0}
                      </td>
                      {/* 手数料 */}
                      <td className="text-center align-middle p-1">
                        {data.refund_total ? Number(data.total) - Number(data.refund_total) : Number(data.total)}
                      </td>
                      {/* ステータス */}
                      <td className="text-center align-middle p-1">
                        {constClass.STATUS_NAME[data.status]}
                      </td>
                      {/*更新ユーザ*/}
                      <td className="text-center align-middle p-1">
                        {(data.upd_name !== "booking" && data.upd_name !== "orders") ? data.upd_name : ""}
                      </td>
                      {/* 処理 */}
                      <td className="text-center align-middle text-nowrap p-1 print-none">
                        {renderButton(data, constClass.STATUS.FIN, constClass.STATUS_NAME.FIN)}
                        {renderCancelButton(data)}
                      </td>
                    </tr>
                  ))
                  }
                </tbody>
              </table>
            }
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className="container">
      <div className="row d-none"><div className="col-12">{util.inspect(bookData)}</div></div>
      <div className="row d-none"><div className="col-12">{util.inspect(props.user)}</div></div>
      {bookData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {bookData !== null && renderList()}
    </div>
  )
}

export default TrainBookingList;